/*
* 卡贷默认
smsTplId: 10001150,
  smsTplVersion: 3
贸易贷产品
partnerName = ZHONGXINAPI
productType = 17
tpl_id = 10004117
tpl_ver = 2


光大薪期贷产品
product_type = 15
tpl_id = 10005097
tpl_ver = 2


得意花产品
product_type = 11
tpl_id = 10005401
tpl_ver = 1
  **/

export default function (productType, partnerName) {
  var template= {
    smsTplId: 10006602,
    smsTplVersion: 1
  }
  switch (productType){
    case 26:
      template = {
        smsTplId: 10006193,
        smsTplVersion: 1
      }
      break;
    case 22:
      template = {
        smsTplId: 10005726,
        smsTplVersion: 3
      }
      break;
    case 17:
      if(partnerName === 'ZHONGXINAPI'){
        template = {
          smsTplId: 10005463,
          smsTplVersion: 2
        }
      }
      break;
    case 15:
      template = {
        smsTplId: 10005462,
        smsTplVersion: 2
      }
      break;
    case 11:
      template = {
        smsTplId: 10006601,
        smsTplVersion: 1
      }
      break;
    default:
      break;
  }
  return template
}
